import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { errorMessage } from "@/lib/api";
import { todayISO } from "@/lib/services";

// state: { title, description, dateLabel?, noteLabel?, submitLabel, onSubmit({ on, note }) }
export const DayDialog = ({ state, onClose }) => {
  const [on, setOn] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (state) { setOn(""); setNote(""); } }, [state]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await state.onSubmit({ on, note });
      onClose();
    } catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!state} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-slate-700 bg-slate-900 sm:max-w-md" data-testid="day-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-bold">{state?.title}</DialogTitle>
          <DialogDescription>{state?.description}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {state?.dateLabel && (
            <div className="space-y-1.5">
              <Label htmlFor="day_on">{state.dateLabel}</Label>
              <Input id="day_on" type="date" required min={todayISO()} value={on} onChange={(e) => setOn(e.target.value)} className="h-10 bg-slate-950" data-testid="day-dialog-date-input" />
            </div>
          )}
          {state?.noteLabel && (
            <div className="space-y-1.5">
              <Label htmlFor="day_note">{state.noteLabel}</Label>
              <Textarea id="day_note" rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Opcional" className="bg-slate-950" data-testid="day-dialog-note-input" />
            </div>
          )}
          <DialogFooter className="gap-2">
            <Button type="button" variant="ghost" onClick={onClose} data-testid="day-dialog-cancel">Cancelar</Button>
            <Button type="submit" disabled={busy} className="rounded-full font-semibold" data-testid="day-dialog-submit">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} {state?.submitLabel}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
